import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCodeDocumentationApi } from "../../end-points/codeDocumentation";
import { toast } from "react-toastify";

const initialState = {
  showDocumentation: false,
  showOverview: false,
  repoPath: "",
  source_language: "",
  target_language: "",
  loading: false,
  documentation: ""
}

export const getCodeDocumentation = createAsyncThunk(
  "codeDocumentation/getCodeDocumentation", getCodeDocumentationApi
)

export const codeDocumentationSlice = createSlice({
  name: "codeDocumentation",
  initialState,
  reducers: {
    setShowDocumentation: (state, action) => {
      state.showDocumentation = action.payload;
      if (action.payload === true) {
        state.showOverview = false;
      }
    },
    setShowOverview: (state, action) => {
      state.showOverview = action.payload;
      if (action.payload === true) {
        state.showDocumentation = false;
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCodeDocumentation.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(getCodeDocumentation.fulfilled, (state, action) => {
      console.log("Success...", state, action);
      state.documentation = action.payload.documentationResult;
      state.showDocumentation = true;
      state.showOverview = false;
      state.loading = false;
      console.log("Documentation", state.documentation);
    })
    builder.addCase(getCodeDocumentation.rejected, (state, action) => {
      console.log("Error", state, action);
      toast.error(action.error.message)
      state.loading = false;
    })
  }

})

// Action creators are generated for each case reducer function
export const { setShowDocumentation, setShowOverview } = codeDocumentationSlice.actions;

export default codeDocumentationSlice.reducer